/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

const Story = () => (
  <div className="container" style={{ marginTop: '1rem' }}>
    <h1
      className="d-flex justify-content-center"
      style={{
        fontFamily: 'Arial, sans-serif', fontSize: '70px', fontWeight: 'bold', backgroundColor: '#2AA5A0', backgroundImage: 'linear-gradient(90deg, #E3635D, #7AA2A9)', webkitBackgroundClip: 'text', webkitTextFillColor: 'transparent',
      }}
    >
      Как всё начиналось
    </h1>
    <br />
    <p className="d-flex justify-content-center">
      В давние времена в мир обычных смертных вошли сущности,
      которые внешне ничем не отличались от людей
    </p>
  </div>
);

export default Story;
